import api from './axiosConfig';

const authService = {
  login: (credentials) => api.post('/login', credentials),
  logout: () => api.post('/logout'),
  getProfile: () => api.get('/profile'),
  updateProfile: (data) => api.put('/profile', data),
  changePassword: (data) => api.put('/change-password', data),
};

export default authService;
